module.exports = __webpack_public_path__ + "img/IMG_3119_L_Wood_MockedUp.6f40de2f.jpg";